<script type="text/ecmascript-6">
    import Layout from '../layouts/MainLayout.vue'
    import Chart from 'chart.js';
    import {mapGetters} from "vuex";
    import DateRange from "../components/DateRange";
    import TopHeader from "../components/TopHeader";

    export default {
        components: {DateRange, Layout, TopHeader },

        /**
         * The component's data.
         */
        data: () => ({

            posts: [],

            dateRange: {
                startDate: '2019-12-10',
                endDate: '2019-12-20',
            },
            reachChart: null,
            engagementChart: null,
        }),

        watch: {
            isLoading(newData) {
                if (!newData) {
                    this.doughnutChart();
                }
            }
        },

        computed: {
            ...mapGetters({
                isLoading: 'getIsLoading',
                isShow: 'getIsShow',
                dateTime: 'getDateTime',
                ownPageData: 'getOwnPageData',
                isPreview: 'getIsPreview',
            })
        },

        beforeDestroy() {
            if (this.reachChart) {
                this.reachChart.destroy();
            }

            if (this.engagementChart) {
                this.engagementChart.destroy();
            }
        },

        mounted() {
            this.configChart();
            this.doughnutChart();
        },

        methods: {

            configChart() {
                Chart.pluginService.register({
                    beforeDraw: function(chart) {
                        if (chart.config.type === "doughnut"){
                            var width = chart.chart.width,
                                height = chart.chart.height,
                                ctx = chart.chart.ctx;

                            ctx.restore();
                            var fontSize = (height / 114).toFixed(2);
                            ctx.font = fontSize + "em 'Nunito',-apple-system, BlinkMacSystemFont";
                            ctx.fontFamily = '"Nunito", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';
                            ctx.textBaseline = "middle";

                            let text = chart.chart.options.title.text;

                            var textX = Math.round((width - ctx.measureText(text).width) / 2),
                                textY = height / 2;

                            ctx.fillText(text, textX, textY);
                            ctx.save();
                        }
                    }
                });
            },

            doughnutChart() {

                var ctx = document.getElementById("reachChart").getContext('2d');
                var ctx2 = document.getElementById("engagementChart").getContext('2d');

                if (this.reachChart) {
                    this.reachChart.destroy();
                }

                if (this.engagementChart) {
                    this.engagementChart.destroy();
                }

                this.reachChart = new Chart(ctx, {
                    type: 'doughnut',
                    data: {
                        labels: ["Video", "Photo"],
                        datasets: [{
                            data: [this.ownPageData.reach_by_photo,	this.ownPageData.reach_by_video], // Specify the data values array
                            borderColor: ['#D3D3D3', '#4A4A4A'], // Add custom color border
                            backgroundColor: ['#D3D3D3', '#4A4A4A'], // Add custom color background (Points and Fill)
                            borderWidth: 1 // Specify bar border width
                        }]},
                    options: {
                        cutoutPercentage : 80,
                        responsive: false, // Instruct chart js to respond nicely.
                        maintainAspectRatio: false, // Add to prevent default behaviour of full-width/height
                        legend: {
                            display: false
                        },
                        title: {
                            text: 'REACH'
                        }
                    },
                });

                this.engagementChart = new Chart(ctx2, {
                    type: 'doughnut',
                    data: {
                        labels: ["Video", "Photo"],
                        datasets: [{
                            data: [this.ownPageData.engagement_by_video, this.ownPageData.engagement_by_photo], // Specify the data values array
                            borderColor: ['#D3D3D3', '#4A4A4A'], // Add custom color border
                            backgroundColor: ['#D3D3D3', '#4A4A4A'], // Add custom color background (Points and Fill)
                            borderWidth: 1 // Specify bar border width
                        }]},
                    options: {
                        cutoutPercentage : 80,
                        responsive: false, // Instruct chart js to respond nicely.
                        maintainAspectRatio: false, // Add to prevent default behaviour of full-width/height
                        legend: {
                            display: false
                        },
                        title: {
                            text: 'ENGAGEMENT'
                        }
                    }
                });
            },
        }
    }
</script>

<template>
    <layout>
        <div :class="{'container-fluid' : !isPreview }" v-show="!isLoading">
            <date-range></date-range>

            <div class="card" :class="[{'mb-3': !isPreview}, {'border-0': isPreview}]" v-show="isShow">
                <div class="card-body">

                    <top-header name="Content Performance Report"></top-header>

                    <div class="row mt-5">
                        <div class="col-4">
                            <h2 class="text-black pb-3">POST CREATED</h2>
                            <div class="d-flex flex-row">
                                <div>
                                    <h1 class="text-black font-weight-bolder">{{ ownPageData.post.value }}</h1>
                                </div>
                                <div class="pl-3 pt-1">
                                    <template v-if="ownPageData.post.percent > 0">
                                        <i class="fas fa-caret-up text-success fa-2x"></i>
                                        <h3 class="text-success d-inline">{{ ownPageData.post.percent }}%</h3>
                                    </template>
                                    <template v-else>
                                        <i class="fas fa-caret-down text-warning fa-2x"></i>
                                        <h3 class="text-warning d-inline">{{ ownPageData.post.percent }}%</h3>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="d-flex flex-row">
                                <div>
                                    <i class="fab fa-instagram fa-3x d-block text-black pb-4"></i>
                                    <i class="fas fa-video fa-3x d-block text-black pt-2"></i>
                                </div>
                                <div class="pl-5">
                                    <h1 class="text-black font-weight-bolder pb-4">{{ ownPageData.post_by_photo }}</h1>
                                    <h1 class="text-black font-weight-bolder">{{ ownPageData.post_by_video.toString().padStart(2, '0') }}</h1>
                                </div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="d-flex flex-row">
                                <div class="d-flex flex-row">
                                    <i class="fab fa-instagram text-black"></i>
                                    <canvas width="100px" height="100px" id="reachChart"></canvas>
                                    <i class="fas fa-video text-black mt-auto"></i>
                                </div>
                                <div class="d-flex flex-row pl-5">
                                    <i class="fab fa-instagram text-black"></i>
                                    <canvas width="100px" height="100px" id="engagementChart"></canvas>
                                    <i class="fas fa-video text-black mt-auto"></i>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mt-5 mb-5">
                        <hr>
                    </div>

                    <div class="row">
                        <div class="col-4">
                            <div class="d-flex flex-row">
                                <div>
                                    <i class="fas fa-bullseye fa-2x text-black"></i>
                                </div>
                                <div class="pl-4">
                                    <h3 class="text-black">{{ numberFormat(ownPageData.avg_reach_per_post.value)}}
                                        <template v-if="ownPageData.avg_reach_per_post.percent > 0">
                                            <i class="fas fa-caret-up text-success pb-1" style="font-size: 1.2rem;">{{ ownPageData.avg_reach_per_post.percent }}%</i>
                                        </template>
                                        <template v-else>
                                            <i class="fas fa-caret-down text-warning pb-1" style="font-size: 1.2rem;">{{ ownPageData.avg_reach_per_post.percent }}%</i>
                                        </template>
                                    </h3>
                                    <h5 class="text-black">AVERAGE REACH PER POST</h5>
                                </div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="d-flex flex-row">
                                <div>
                                    <i class="fas fa-paperclip fa-2x text-black"></i>
                                </div>
                                <div class="pl-4">
                                    <h3 class="text-black">{{ numberFormat(ownPageData.avg_engagement_rate.value) }}
                                        <template v-if="ownPageData.avg_engagement_rate.percent > 0">
                                            <i class="fas fa-caret-up text-success pb-1" style="font-size: 1.2rem;">{{ ownPageData.avg_engagement_rate.percent }}%</i>
                                        </template>
                                        <template v-else>
                                            <i class="fas fa-caret-down text-warning pb-1" style="font-size: 1.2rem;">{{ ownPageData.avg_engagement_rate.percent }}%</i>
                                        </template>
                                    </h3>
                                    <h5 class="text-black">AVERAGE REACH PER POST</h5>
                                </div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="d-flex flex-row">
                                <div>
                                    <i class="fab fa-facebook-f fa-2x text-black" style="padding-right: 0.8rem"></i>
                                </div>
                                <div class="pl-4">
                                    <h3 class="text-black">{{ numberFormat(ownPageData.post_engagement.value) }}
                                        <template v-if="ownPageData.post_engagement.percent > 0">
                                            <i class="fas fa-caret-up text-success pb-1" style="font-size: 1.2rem;">{{ ownPageData.post_engagement.percent }}%</i>
                                        </template>
                                        <template v-else>
                                            <i class="fas fa-caret-down text-warning pb-1" style="font-size: 1.2rem;">{{ ownPageData.post_engagement.percent }}%</i>
                                        </template>
                                    </h3>
                                    <h5 class="text-black">POST ENGAGEMENT</h5>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mt-5">
                        <div class="col-4">
                            <div class="d-flex flex-row">
                                <div>
                                    <i class="far fa-flag fa-2x text-black"></i>
                                </div>
                                <div class="pl-4">
                                    <h3 class="text-black">{{ numberFormat(ownPageData.post_reach.value )}}
                                        <template v-if="ownPageData.post_reach.percent > 0">
                                            <i class="fas fa-caret-up text-success pb-1" style="font-size: 1.2rem;">{{ ownPageData.post_reach.percent }}%</i>
                                        </template>
                                        <template v-else>
                                            <i class="fas fa-caret-down text-warning pb-1" style="font-size: 1.2rem;">{{ ownPageData.post_reach.percent }}%</i>
                                        </template>
                                    </h3>
                                    <h5 class="text-black">POST REACH</h5>
                                </div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="d-flex flex-row">
                                <div>
                                    <i class="fab fa-chromecast fa-2x text-black"></i>
                                </div>
                                <div class="pl-4">
                                    <h3 class="text-black">{{ numberFormat(ownPageData.video_view_time.value) }} min
                                        <template v-if="ownPageData.video_view_time.percent > 0">
                                            <i class="fas fa-caret-up text-success pb-1" style="font-size: 1.2rem;">{{ ownPageData.video_view_time.percent }}%</i>
                                        </template>
                                        <template v-else>
                                            <i class="fas fa-caret-down text-warning pb-1" style="font-size: 1.2rem;">{{ ownPageData.video_view_time.percent }}%</i>
                                        </template>
                                    </h3>
                                    <h5 class="text-black">VIDEO VIEW TIME</h5>
                                </div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="d-flex flex-row">
                                <div>
                                    <i class="fa fa-film fa-2x text-black"></i>
                                </div>
                                <div class="pl-4">
                                    <h3 class="text-black">{{ numberFormat(ownPageData.three_second_video_view.value) }}
                                        <template v-if="ownPageData.three_second_video_view.percent > 0">
                                            <i class="fas fa-caret-up text-success pb-1" style="font-size: 1.2rem;">{{ ownPageData.three_second_video_view.percent }}%</i>
                                        </template>
                                        <template v-else>
                                            <i class="fas fa-caret-down text-warning pb-1" style="font-size: 1.2rem;">{{ ownPageData.three_second_video_view.percent }}%</i>
                                        </template>
                                    </h3>
                                    <h5 class="text-black">3s VIDEO VIEW</h5>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mt-5 mb-2">
                        <div class="col-md-12 text-black">
                            <table class="table">
                                <thead>
                                <tr>
                                    <th scope="col">Date</th>
                                    <th scope="col">Post</th>
                                    <th scope="col">Type</th>
                                    <th scope="col">Reach</th>
                                    <th scope="col"><i class="far fa-heart"></i></th>
                                    <th scope="col"><i class="far fa-comment-alt"></i></th>
                                    <th scope="col"><i class="fa fa-retweet"></i></th>
                                    <th scope="col">Engagement</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="post in ownPageData.posts" v-bind:key="post.id">
                                    <th scope="row">
                                        {{ moment(post.date).format('DD MMM YYYY hh:mm')}}
                                    </th>
                                    <td>
                                        <img :src="post.picture" width="50" alt=""/>
                                        <div class="pt-2 pl-3 pb-2 d-inline-block">
                                            <h6> {{ post.message.substring(0,70) }}...</h6>
                                        </div>
                                    </td>
                                    <td v-html="post.type"></td>
                                    <td>{{ abbrNum(post.reach, 2)}}</td>
                                    <td>{{ numberFormat(post.reactions) }}</td>
                                    <td>{{ numberFormat(post.comments) }}</td>
                                    <td>{{ numberFormat(post.shares) }}</td>
                                    <th>{{ post.engagement }}%</th>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </layout>
</template>
